<style scoped>
    .label{
        display: inline-block;
        vertical-align: top;
        width: 220px;
        padding: 2px;
        margin: 2px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        font-weight: bold;
        cursor: pointer;
    }
    .label:hover{
        background: #dddee1;
    }
    .cur-label{
        border-color: #2b62e4;
        box-shadow: 0 0 3px #2b62e4;
    }
    .label-name{
        border-bottom: 1px solid #dddee1;
        padding: 3px 0;
        margin-bottom: 3px;
    }
    .label-line{
        margin-bottom: 2px;
    }
    .label-label{
        display: inline-block;
        vertical-align: middle;
        width: 40px;
        text-align: center;
    }
    .label-value{
        display: inline-block;
        width: 60px;
    }
    .label-point{
        display: inline-block;
        vertical-align: middle;
        width: 40px;
    }
    .label-btn{
        display: inline-block;
        vertical-align: middle;
        height: 20px;
        width: 20px;
        line-height: 20px;
        text-align: center;
        border: 1px solid #dddee1;
        border-radius: 10px;
        cursor: pointer;
    }
    .label-btn:hover{
        background: #dddee1;
    }
    input{
        width: 100%;
        padding: 0 2px;
        border: 1px solid #dddee1;
        border-radius: 4px;
    }
    .ivu-cell{
        padding: 2px 4px;
    }
</style>
<template>
  <div
    class="label"
    @click.stop="click"
    @keydown.stop=""
  >
    <div class="line text-right">
      <Poptip
        confirm
        transfer
        title="您确认删除吗?"
        @on-ok="del"
      >
        <Button
          size="small"
          shape="circle"
          icon="md-close"
        />
      </Poptip>
    </div>
    <CellGroup>
      <Cell>
        <span>文字</span>
        <i-input
          slot="extra"
          v-model="label.text"
          size="small"
          @on-change="dataChange"
        />
      </Cell>
      <Cell>
        <span>X</span>
        <InputNumber
          slot="extra"
          v-model="label.x"
          size="small"
          :min="0"
          :step="1"
          @on-change="dataChange"
        />
      </Cell>
      <Cell>
        <span>Y</span>
        <InputNumber
          slot="extra"
          v-model="label.y"
          size="small"
          :min="0"
          :step="1"
          @on-change="dataChange"
        />
      </Cell>
      <Cell>
        <span>大小</span>
        <InputNumber
          slot="extra"
          v-model="label.fontSize"
          size="small"
          :min="0"
          :step="1"
          @on-change="dataChange"
        />
      </Cell>
      <Cell>
        <span>颜色</span>
        <i-colorPicker
          slot="extra"
          v-model="label.fillStyle"
          recommend
          size="small"
          @on-change="dataChange"
        >
</ColorPicker>
        </i-colorpicker>
      </Cell>
      <Cell>
        <span>粗细</span>
        <Select
          slot="extra"
          v-model="label.fontWeight"
          size="small"
          @on-change="dataChange"
        >
          <Option value="normal">
            正常
          </Option>
          <Option value="bold">
            粗体
          </Option>
          <Option value="lighter">
            细体
          </Option>
        </Select>
      </Cell>
    </CellGroup>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  export default {
    props: ['label', 'index'],
    data() {
      return {
        //
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      dataChange() {
        this.$emit('change');
      },
      click(ev) {
        const is_add = ev.altKey || ev.shiftKey || ev.ctrlKey;
        this.$emit('click', this.label, is_add);
      },
      copy() {
        this.$emit('copy', this.label, this.index);
        this.$emit('change');
      },
      del() {
        this.$emit('del', this.label);
        this.$emit('change');
      },
      addPoint(index) {
        this.label.data.points.push({x: '', y: ''});
        this.$emit('change');
      },
      delPoint(index) {
        this.label.data.points.splice(index, 1);
        this.$emit('change');
      },
    }
  }
</script>
